<script lang="ts">
	type Props = {
		size?: number
		gap?: number
		color?: string
		label?: string
		backgroundColor?: string
	}

	let {
		size = 6, // dot size in px
		gap = 6, // gap in px
		color, // dots color
		label = 'Lädt…', // aria-label
		backgroundColor
	}: Props = $props()
</script>

<div
	class="loading"
	role="status"
	aria-label={label}
	style:--color={color}
	style:--map-load-background-color={backgroundColor}
	style:--size={size + 'px'}
	style:--gap={gap + 'px'}
>
	<span class="dot" aria-hidden="true"></span>
	<span class="dot" aria-hidden="true"></span>
	<span class="dot" aria-hidden="true"></span>
</div>

<style>
	.loading {
		display: flex;
		align-items: center;
		gap: var(--gap);
		background-color: var(--map-load-background-color, white);
		padding: 0.875rem 1.5rem;
		border-radius: 9999px;
	}

	.dot {
		width: var(--size);
		height: var(--size);
		border-radius: 9999px;
		background: var(--color, #000);
		opacity: 0.2;
		animation: dot-pulse 1.05s infinite ease-in-out;
	}

	.dot:nth-child(1) {
		animation-delay: 0ms;
	}

	.dot:nth-child(2) {
		animation-delay: 150ms;
	}

	.dot:nth-child(3) {
		animation-delay: 300ms;
	}

	@keyframes dot-pulse {
		0%,
		80%,
		100% {
			opacity: 0.2;
			transform: translateY(0);
		}

		40% {
			opacity: 1;
			transform: translateY(-1px);
		}
	}
</style>
